import { UPDATE_REGISTER_STUDENT } from "../actions/registerStudent"

const initialState = {
  school: null,
  isFetched: false,
  isInvalidId: false,
  created: false,
  error: null
}

export default function registerStudentReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_REGISTER_STUDENT:
      return Object.assign({}, state, action.payload)

    default:
      return state
  }
}
